import { defineSemanticTokens, defineTokens } from '@pandacss/dev'

const tokens = defineTokens.colors({
  light: {
    '1': { value: '#fbfefd' },
    '2': { value: '#f4fbf7' },
    '3': { value: '#e6f7ed' },
    '4': { value: '#d6f1e3' },
    '5': { value: '#c3e9d7' },
    '6': { value: '#acdec8' },
    '7': { value: '#8bceb6' },
    '8': { value: '#56ba9f' },
    '9': { value: '#29a383' },
    '10': { value: '#26997b' },
    '11': { value: '#208368' },
    '12': { value: '#1d3b31' },
    a1: { value: '#00c08004' },
    a2: { value: '#00a3460b' },
    a3: { value: '#00ae4819' },
    a4: { value: '#00a85129' },
    a5: { value: '#00a2553c' },
    a6: { value: '#009a5753' },
    a7: { value: '#00945f74' },
    a8: { value: '#00976ea9' },
    a9: { value: '#00916bd6' },
    a10: { value: '#008764d9' },
    a11: { value: '#007152df' },
    a12: { value: '#002217e2' },
  },
  dark: {
    '1': { value: '#0d1512' },
    '2': { value: '#121c18' },
    '3': { value: '#0f2e22' },
    '4': { value: '#0b3b2c' },
    '5': { value: '#114837' },
    '6': { value: '#1b5745' },
    '7': { value: '#246854' },
    '8': { value: '#2a7e68' },
    '9': { value: '#29a383' },
    '10': { value: '#27b08b' },
    '11': { value: '#1fd8a4' },
    '12': { value: '#adf0d4' },
    a1: { value: '#00de4505' },
    a2: { value: '#27fba60c' },
    a3: { value: '#02f99920' },
    a4: { value: '#00ffaa2d' },
    a5: { value: '#11ffb63b' },
    a6: { value: '#34ffc24b' },
    a7: { value: '#45fdc75e' },
    a8: { value: '#48ffcf75' },
    a9: { value: '#38feca9d' },
    a10: { value: '#31fec7ab' },
    a11: { value: '#21fec0d6' },
    a12: { value: '#b8ffe1ef' },
  },
})
const semanticTokens = defineSemanticTokens.colors({
  '1': { value: { _light: '{colors.jade.light.1}', _dark: '{colors.jade.dark.1}' } },
  '2': { value: { _light: '{colors.jade.light.2}', _dark: '{colors.jade.dark.2}' } },
  '3': { value: { _light: '{colors.jade.light.3}', _dark: '{colors.jade.dark.3}' } },
  '4': { value: { _light: '{colors.jade.light.4}', _dark: '{colors.jade.dark.4}' } },
  '5': { value: { _light: '{colors.jade.light.5}', _dark: '{colors.jade.dark.5}' } },
  '6': { value: { _light: '{colors.jade.light.6}', _dark: '{colors.jade.dark.6}' } },
  '7': { value: { _light: '{colors.jade.light.7}', _dark: '{colors.jade.dark.7}' } },
  '8': { value: { _light: '{colors.jade.light.8}', _dark: '{colors.jade.dark.8}' } },
  '9': { value: { _light: '{colors.jade.light.9}', _dark: '{colors.jade.dark.9}' } },
  '10': { value: { _light: '{colors.jade.light.10}', _dark: '{colors.jade.dark.10}' } },
  '11': { value: { _light: '{colors.jade.light.11}', _dark: '{colors.jade.dark.11}' } },
  '12': { value: { _light: '{colors.jade.light.12}', _dark: '{colors.jade.dark.12}' } },
  a1: { value: { _light: '{colors.jade.light.a1}', _dark: '{colors.jade.dark.a1}' } },
  a2: { value: { _light: '{colors.jade.light.a2}', _dark: '{colors.jade.dark.a2}' } },
  a3: { value: { _light: '{colors.jade.light.a3}', _dark: '{colors.jade.dark.a3}' } },
  a4: { value: { _light: '{colors.jade.light.a4}', _dark: '{colors.jade.dark.a4}' } },
  a5: { value: { _light: '{colors.jade.light.a5}', _dark: '{colors.jade.dark.a5}' } },
  a6: { value: { _light: '{colors.jade.light.a6}', _dark: '{colors.jade.dark.a6}' } },
  a7: { value: { _light: '{colors.jade.light.a7}', _dark: '{colors.jade.dark.a7}' } },
  a8: { value: { _light: '{colors.jade.light.a8}', _dark: '{colors.jade.dark.a8}' } },
  a9: { value: { _light: '{colors.jade.light.a9}', _dark: '{colors.jade.dark.a9}' } },
  a10: { value: { _light: '{colors.jade.light.a10}', _dark: '{colors.jade.dark.a10}' } },
  a11: { value: { _light: '{colors.jade.light.a11}', _dark: '{colors.jade.dark.a11}' } },
  a12: { value: { _light: '{colors.jade.light.a12}', _dark: '{colors.jade.dark.a12}' } },
  default: { value: { _light: '{colors.jade.light.9}', _dark: '{colors.jade.dark.9}' } },
  emphasized: { value: { _light: '{colors.jade.light.10}', _dark: '{colors.jade.dark.10}' } },
  fg: { value: { _light: 'white', _dark: 'white' } },
  text: { value: { _light: '{colors.jade.light.a11}', _dark: '{colors.jade.dark.a11}' } },
})

export default {
  name: 'jade',
  tokens,
  semanticTokens,
}
